import { LazyLoadComponent } from '@src/components';
import { lazy } from 'react';

const ProfilePage = lazy(() =>
  import('@src/pages/Dashboard').then((module) => ({
    default: module.Profile,
  }))
);

export function ProfileContainer() {
  return <LazyLoadComponent Component={<ProfilePage />} />;
}
